<template>
  <div>
      <breadcrumb :breadcrumb="breadcrumb" />
      <div class="search-line">
        <div style="display:flex;justify-content:flex-start;align-items:center;">
          <button-add v-if="permissionCodes.indexOf('004025001') !== -1" :value="addOneBtnValue" :pathName="addOneAccountName"></button-add>
          <button-add v-if="permissionCodes.indexOf('004025001') !== -1" :value="addManyBtnValue" :pathName="addManyAccountName"></button-add>
        <button-upload
          :cathUrl="uploadUrl"
          :onSuccess="onUploadSuccess"
          @getpage="getPage"
          v-if="permissionCodes.indexOf('004025004') !== -1"
          value="导入"/>
        <button-export
          :href="exportUrl"
          :beforeDownload="beforeDownload"
          download="download.xls"
          v-if="permissionCodes.indexOf('004025005') !== -1"
          value="导出"/>
        </div>
        <input-search :placeholder="searchPlaceholder" @search="searchKey"/>
      </div>
      <div class="search-line">
        <input-select selectTitle="是否固定车位" :selectKey="'fix'" :selectData="fixTypeList" @search="search"/>
        <input-select selectTitle="是否绑定" :selectKey="'bind'" :selectData="bindTypeList" @search="search"/>
        <input-select selectTitle="车位区域" :selectKey="'areaCode'" :selectData="areaList" @search="search"/>
      </div>
      <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :pageNum="pageNum" :pageSize="pageSize" :operationArr="operationArr" @changePagination="changePagination" :total="total" @deleteLine="deleteLine" @goToModifyPage="goToModifyPage" @changeSwitch="changeSwitch"/>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import InputSelect from "../../../components/Input/InputSelect";
import InputSearch from "../../../components/Input/InputSearch";
import TableMain from "../../../components/Table/TableMain";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";
import ButtonCancel from "../../../components/Button/ButtonCancel";

export default {
  components: {
    ButtonCancel,
    TableMain,
    InputSelect,
    ButtonUpload,
    ButtonExport,
    InputSearch,
    ButtonAdd,
    Breadcrumb
  },
  name: "parking-lot-manage",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "车位信息"
        }
      ],
      uploadUrl: "",
      exportUrl: "",
      searchPlaceholder: "车位号",
      addOneBtnValue: "单个添加",
      addManyBtnValue: "批量添加",
      addOneAccountName: "parking-lot-add-one",
      addManyAccountName: "parking-lot-add-many",
      tableHead: [
        {
          prop: "areaName",
          label: "车位区域"
        },
        {
          prop: "parkLotNumber",
          label: "车位号"
        },
        {
          prop: "fix",
          label: "是否固定车位",
          active: "是",
          inactive: "否",
          isSwitch: true
        },
        {
          prop: "bindStatusText",
          label: "是否绑定"
        },
        {
          prop: "bindCarNumber",
          label: "绑定的车牌号"
        }
      ],
      fixTypeList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: true,
          label: "是"
        },
        {
          key: false,
          label: "否"
        }
      ],
      bindTypeList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: true,
          label: "是"
        },
        {
          key: false,
          label: "否"
        }
      ],
      areaList: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      tableData: [],
      requestData: {
        searchKey: "",
        fixTypeList: "",
        fix: "",
        bind: "",
        areaCode: ""
      },
      operationArr: ["modify", "delete"]
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
    this.uploadUrl = api.importParkingLot;
  },
  activated() {
    this.getPage();
    this.getParkingLotAreaList();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportParkingLot}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&fix=${
        this.requestData.fix
      }&bind=${this.requestData.bind}&areaCode=${this.requestData.areaCode}`;
    },
    getParkingLotAreaList(searchKey) {
      this.$axios
        .post(api.getParkingLotAreaList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            list.map(v => {
              v.key = v.code;
              v.label = v.parkingLotAreaName;
            });
            this.areaList = list;
            this.areaList.unshift({ key: "", label: "全部" });
          }
        })
        .catch(errorHandler("获取物资类目列表失败"));
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getParkingLotPage, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            this.total = res.data.data.total;
            let list = res.data.data.list;
            this.tableData = list;
            list.map(v => {
              // if (v.fix) {
              //   v.fixStatusText = "是";
              // } else {
              //   v.fixStatusText = "否";
              // }
              if (v.bind) {
                v.bindStatusText = "是";
              } else {
                v.bindStatusText = "否";
              }
            });
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSwitch(data) {
      this.$confirm("是否确认修改固定车位状态？", "提示")
        .then(() => {
          for (let i in data) {
            if (data[i] === "--") {
              data[i] = "";
            }
          }
          if (data.detailMap === "") {
            data.detailMap = null;
          }
          this.$axios
            .post(api.updateParkingLot, data)
            .then(res => {
              nSuccess("修改成功");
              this.getPage();
            })
            .catch(errorHandler("修改失败"));
          this.getPage();
        })
        .catch(() => {
          this.getPage();
        });
    },
    onUploadSuccess(data) {
      if (data.retCode == 1) {
        nSuccess("导入成功");
        this.pageSize = 10;
        this.pageNum = 1;
        this.getPage();
      } else {
        errorHandler("导入失败")(data);
      }
    },
    //删除
    deleteLine(code) {
      this.$axios
        .post(api.deleteParkingLotByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    },

    //修改
    goToModifyPage(code) {
      this.$router.push({
        path: `/park_server/parking_lot_modify/${code}`
      });
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
</style>

<style scoped lang="less">
.el-switch__label {
  height: 32px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingLot/ParkingLotManage.vue